const GOOGLE_MAPS_STYLE = [
    {
        'featureType': 'poi.attraction',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi.business',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi.medical',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'labels.text',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi.place_of_worship',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi.sports_complex',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    }
];

export default GOOGLE_MAPS_STYLE;



// WEBPACK FOOTER //
// ./src/js/lib/GoogleMapsStyling.js